enum ICC_PRODUCT_STATUS_TYPES {
    FAILED = 'Failed',
    REGISTERED = 'Registered',
}

export default ICC_PRODUCT_STATUS_TYPES;
